import { Entry } from './entry';

Entry.displayName = 'Appearance';

export { Entry as Appearance };

export { Type as AppearanceType } from './enums';

export { getTokenClassNameByType as getAppearanceClassNameByType } from './model';
